module.exports = __webpack_public_path__ + "static/40import-6a896f0a8ba3a15d5eb34c8886774ab9.png";